const styles = (theme) => ({
  root: {
    position: "relative",
    padding: theme.hv.spacing.sm,
    backgroundColor: theme.hv.palette.atmosphere.atmo1,
    overflow: "auto",
  },
});

export default styles;
